/* 
Mixins for use by components displaying overrides.
*/
import lookupMixins from "@/mixins/lookup.mixins";
import * as claim from "@/store/claim-types";

export default {
  mixins: [lookupMixins],
  methods: {
    canEditOverrides(levyCollectionProviderStatus) {
      const hasAnyProviders = this.$store.state.levyCollections.view.data.inScopeProviders > 0;
      const hasPermission = this.$store.getters.claims.includes(claim.LCP_TASK_EDIT_OVERRIDE);
      const levyCollectionStatus = this.$store.state.levyCollections.view.data.status;
      const isAllowableLevyCollectionStatus = this.doesLookupHaveAttribute(
        levyCollectionStatus,
        "CanEditOverrides",
        this.lookups.levyCollectionStatuses
      );
      let isAllowableProviderStatus = true;
      if (levyCollectionProviderStatus) {
        isAllowableProviderStatus = !this.doesLookupHaveAttribute(
          levyCollectionProviderStatus,
          "HasBeenInvoiced",
          this.lookups.levyCollectionProviderStatuses
        );
      }
      return hasAnyProviders && hasPermission && isAllowableLevyCollectionStatus && isAllowableProviderStatus;
    }
  }
};
